import { render, staticRenderFns } from "./RequerimientoDetail.vue?vue&type=template&id=e66dc96c&scoped=true&"
import script from "./RequerimientoDetail.vue?vue&type=script&lang=js&"
export * from "./RequerimientoDetail.vue?vue&type=script&lang=js&"
import style0 from "./RequerimientoDetail.vue?vue&type=style&index=0&id=e66dc96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66dc96c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VFlex,
  VIcon,
  VProgressLinear,
  VSpacer,
  VSubheader,
  VTooltip,
})
